<script>
import { onMounted, ref } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'HeroSection',
  setup() {
    const heroLeft = ref(null);
    const heroRight = ref(null);

    onMounted(() => {
      const timeline = gsap.timeline()
      timeline.fromTo(
          heroLeft.value,
          { x: "-100%" },
          { x: "0%", duration: 1, ease: "power2.out" }
      )
      timeline.fromTo(
          heroRight.value,
          { x: "100%" },
          { x: "0%", duration: 1, ease: "power2.out" },
          "<"
      )
    })
    return {
      heroLeft,
      heroRight,
    }
  }
}

</script>

<template>
  <div class="hero gap-16 flex flex-wrap flex:block items-center px-4 mx-auto max-w-screen-xl lg:grid lg:grid-cols-2 lg:px-6">
    <div ref="heroLeft" class="hero-left font-light text-gray-500 sm:text-lg">
      <h1 class="max-w-2xl mb-4 text-4xl font-extrabold tracking-tight leading-none lg:text-5xl xl:text-6xl dark:text-white">
        La bière local la plus dingo que tu connaisses
      </h1>
      <p class="max-w-2xl mb-6 font-light text-gray-500 lg:mb-8 lg:text-lg ">
        Découvrez la bière local la plus aberrante du marché. Avec la déglingo redécouvrez vos soirées entre amis !
      </p>
      <router-link to="/boutique" class="inline-flex items-center w-full lg:w-auto mb-2 justify-center px-5 py-3 mr-3 text-base font-medium text-center text-white rounded-lg bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300">
        Achetez nos bières
      </router-link>
      <router-link to="/histoire" class="inline-flex items-center w-full lg:w-auto justify-center px-5 py-3 text-base font-medium text-center text-gray-900 border border-gray-300 rounded-lg hover:bg-gray-100 focus:ring-4 focus:ring-gray-100">
        Découvrir notre histoire
      </router-link>
    </div>
    <div ref="heroRight" class="hero-right grid grid-cols-2 gap-4 lg:mt-8">
      <img class="w-full rounded-lg" src="../../assets/bouteille_deglingo_1.svg" alt="office content 1">
      <img class="mt-4 w-full lg:mt-10 rounded-lg" src="../../assets/bouteille_deglingo_2.svg" alt="office content 2">
    </div>
  </div>
</template>

<style scoped>

.hero-left {
  transform: translateX(-100%);
  transition: none;
}

.hero-right {
  transform: translateX(100%);
  transition: none;
}

</style>